module.exports = __webpack_public_path__ + "static/shoe-ee7f60c17d56bb12860bb52e6aed0415.jpg";